export default "__VITE_ASSET__DmEEZekS__"